import React from 'react';
import { Text, Link } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { Numeral } from 'pages/billing/components/billing-explainer/billing-explainer.style';

const getCopy = copyFor('billing.billingExplainer.utilityConsolidatedBilling');

interface Props {
  utility: GetUtilityInfoForBillingQuery['plan']['utilityAccounts'][number]['utility'];
}

export const UtilityConsolidatedBilling = ({ utility }: Props) => {
  const { url, displayName } = utility || {};
  const steps = getCopy('steps', {
    utility: displayName || getCopy('utilityPlaceholder'),
  });
  const summary = getCopy('summary');
  const utilityLink = getCopy('utilityLink', { utility: displayName });
  return (
    <>
      {steps.map((text, index) => (
        <Container
          flex
          direction="row"
          margin={{ top: index === 0 ? '16px' : '24px' }}
          key={text}
        >
          <Numeral>
            <Text textStyle="heading400">{index + 1}</Text>
          </Numeral>
          <Text margin={{ left: '16px', top: '0', bottom: '0' }}>{text}</Text>
        </Container>
      ))}
      <Text margin="24px 0">{summary}</Text>
      {url && <Link href={url}>{utilityLink}</Link>}
    </>
  );
};
